import React from 'react';
import {Typography} from "@deere/fuel-react";

export const ListItemPrimary = ({content}) => {
    return (
        <React.Fragment>
            <Typography variant="h4" component="p"
                        gutterBottom>
                {content}
            </Typography>
        </React.Fragment>
    );
};
